
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_18wu0_837ww_5",
  "box": "awsui_box_18wu0_837ww_21",
  "p-variant": "awsui_p-variant_18wu0_837ww_21",
  "color-default": "awsui_color-default_18wu0_837ww_21",
  "b-variant": "awsui_b-variant_18wu0_837ww_21",
  "strong-variant": "awsui_strong-variant_18wu0_837ww_21",
  "code-variant": "awsui_code-variant_18wu0_837ww_21",
  "pre-variant": "awsui_pre-variant_18wu0_837ww_21",
  "samp-variant": "awsui_samp-variant_18wu0_837ww_21",
  "h1-variant": "awsui_h1-variant_18wu0_837ww_25",
  "h2-variant": "awsui_h2-variant_18wu0_837ww_25",
  "h3-variant": "awsui_h3-variant_18wu0_837ww_25",
  "h4-variant": "awsui_h4-variant_18wu0_837ww_25",
  "h5-variant": "awsui_h5-variant_18wu0_837ww_25",
  "small-variant": "awsui_small-variant_18wu0_837ww_29",
  "a-variant": "awsui_a-variant_18wu0_837ww_33",
  "font-size-default": "awsui_font-size-default_18wu0_837ww_37",
  "font-weight-default": "awsui_font-weight-default_18wu0_837ww_77",
  "key-label-variant": "awsui_key-label-variant_18wu0_837ww_117",
  "value-large-variant": "awsui_value-large-variant_18wu0_837ww_122",
  "color-inverted": "awsui_color-inverted_18wu0_837ww_130",
  "color-text-label": "awsui_color-text-label_18wu0_837ww_133",
  "color-text-body-secondary": "awsui_color-text-body-secondary_18wu0_837ww_136",
  "color-text-status-error": "awsui_color-text-status-error_18wu0_837ww_139",
  "color-text-status-success": "awsui_color-text-status-success_18wu0_837ww_142",
  "color-text-status-info": "awsui_color-text-status-info_18wu0_837ww_145",
  "color-text-status-inactive": "awsui_color-text-status-inactive_18wu0_837ww_148",
  "color-inherit": "awsui_color-inherit_18wu0_837ww_151",
  "font-size-body-s": "awsui_font-size-body-s_18wu0_837ww_154",
  "font-size-body-m": "awsui_font-size-body-m_18wu0_837ww_159",
  "font-size-heading-xs": "awsui_font-size-heading-xs_18wu0_837ww_163",
  "font-size-heading-s": "awsui_font-size-heading-s_18wu0_837ww_167",
  "font-size-heading-m": "awsui_font-size-heading-m_18wu0_837ww_172",
  "font-size-heading-l": "awsui_font-size-heading-l_18wu0_837ww_177",
  "font-size-heading-xl": "awsui_font-size-heading-xl_18wu0_837ww_182",
  "font-size-display-l": "awsui_font-size-display-l_18wu0_837ww_187",
  "font-weight-light": "awsui_font-weight-light_18wu0_837ww_192",
  "font-weight-normal": "awsui_font-weight-normal_18wu0_837ww_195",
  "font-weight-bold": "awsui_font-weight-bold_18wu0_837ww_198",
  "font-weight-heavy": "awsui_font-weight-heavy_18wu0_837ww_201",
  "t-left": "awsui_t-left_18wu0_837ww_205",
  "t-right": "awsui_t-right_18wu0_837ww_209",
  "t-center": "awsui_t-center_18wu0_837ww_213",
  "p-n": "awsui_p-n_18wu0_837ww_222",
  "p-top-n": "awsui_p-top-n_18wu0_837ww_226",
  "p-vertical-n": "awsui_p-vertical-n_18wu0_837ww_227",
  "p-right-n": "awsui_p-right-n_18wu0_837ww_231",
  "p-horizontal-n": "awsui_p-horizontal-n_18wu0_837ww_232",
  "p-bottom-n": "awsui_p-bottom-n_18wu0_837ww_236",
  "p-left-n": "awsui_p-left-n_18wu0_837ww_241",
  "p-xxxs": "awsui_p-xxxs_18wu0_837ww_246",
  "p-top-xxxs": "awsui_p-top-xxxs_18wu0_837ww_250",
  "p-vertical-xxxs": "awsui_p-vertical-xxxs_18wu0_837ww_251",
  "p-right-xxxs": "awsui_p-right-xxxs_18wu0_837ww_255",
  "p-horizontal-xxxs": "awsui_p-horizontal-xxxs_18wu0_837ww_256",
  "p-bottom-xxxs": "awsui_p-bottom-xxxs_18wu0_837ww_260",
  "p-left-xxxs": "awsui_p-left-xxxs_18wu0_837ww_265",
  "p-xxs": "awsui_p-xxs_18wu0_837ww_270",
  "p-top-xxs": "awsui_p-top-xxs_18wu0_837ww_274",
  "p-vertical-xxs": "awsui_p-vertical-xxs_18wu0_837ww_275",
  "p-right-xxs": "awsui_p-right-xxs_18wu0_837ww_279",
  "p-horizontal-xxs": "awsui_p-horizontal-xxs_18wu0_837ww_280",
  "p-bottom-xxs": "awsui_p-bottom-xxs_18wu0_837ww_284",
  "p-left-xxs": "awsui_p-left-xxs_18wu0_837ww_289",
  "p-xs": "awsui_p-xs_18wu0_837ww_294",
  "p-top-xs": "awsui_p-top-xs_18wu0_837ww_298",
  "p-vertical-xs": "awsui_p-vertical-xs_18wu0_837ww_299",
  "p-right-xs": "awsui_p-right-xs_18wu0_837ww_303",
  "p-horizontal-xs": "awsui_p-horizontal-xs_18wu0_837ww_304",
  "p-bottom-xs": "awsui_p-bottom-xs_18wu0_837ww_308",
  "p-left-xs": "awsui_p-left-xs_18wu0_837ww_313",
  "p-s": "awsui_p-s_18wu0_837ww_318",
  "p-top-s": "awsui_p-top-s_18wu0_837ww_322",
  "p-vertical-s": "awsui_p-vertical-s_18wu0_837ww_323",
  "p-right-s": "awsui_p-right-s_18wu0_837ww_327",
  "p-horizontal-s": "awsui_p-horizontal-s_18wu0_837ww_328",
  "p-bottom-s": "awsui_p-bottom-s_18wu0_837ww_332",
  "p-left-s": "awsui_p-left-s_18wu0_837ww_337",
  "p-m": "awsui_p-m_18wu0_837ww_342",
  "p-top-m": "awsui_p-top-m_18wu0_837ww_346",
  "p-vertical-m": "awsui_p-vertical-m_18wu0_837ww_347",
  "p-right-m": "awsui_p-right-m_18wu0_837ww_351",
  "p-horizontal-m": "awsui_p-horizontal-m_18wu0_837ww_352",
  "p-bottom-m": "awsui_p-bottom-m_18wu0_837ww_356",
  "p-left-m": "awsui_p-left-m_18wu0_837ww_361",
  "p-l": "awsui_p-l_18wu0_837ww_241",
  "p-top-l": "awsui_p-top-l_18wu0_837ww_370",
  "p-vertical-l": "awsui_p-vertical-l_18wu0_837ww_371",
  "p-right-l": "awsui_p-right-l_18wu0_837ww_375",
  "p-horizontal-l": "awsui_p-horizontal-l_18wu0_837ww_376",
  "p-bottom-l": "awsui_p-bottom-l_18wu0_837ww_380",
  "p-left-l": "awsui_p-left-l_18wu0_837ww_385",
  "p-xl": "awsui_p-xl_18wu0_837ww_390",
  "p-top-xl": "awsui_p-top-xl_18wu0_837ww_394",
  "p-vertical-xl": "awsui_p-vertical-xl_18wu0_837ww_395",
  "p-right-xl": "awsui_p-right-xl_18wu0_837ww_399",
  "p-horizontal-xl": "awsui_p-horizontal-xl_18wu0_837ww_400",
  "p-bottom-xl": "awsui_p-bottom-xl_18wu0_837ww_404",
  "p-left-xl": "awsui_p-left-xl_18wu0_837ww_409",
  "p-xxl": "awsui_p-xxl_18wu0_837ww_414",
  "p-top-xxl": "awsui_p-top-xxl_18wu0_837ww_418",
  "p-vertical-xxl": "awsui_p-vertical-xxl_18wu0_837ww_419",
  "p-right-xxl": "awsui_p-right-xxl_18wu0_837ww_423",
  "p-horizontal-xxl": "awsui_p-horizontal-xxl_18wu0_837ww_424",
  "p-bottom-xxl": "awsui_p-bottom-xxl_18wu0_837ww_428",
  "p-left-xxl": "awsui_p-left-xxl_18wu0_837ww_433",
  "p-xxxl": "awsui_p-xxxl_18wu0_837ww_438",
  "p-top-xxxl": "awsui_p-top-xxxl_18wu0_837ww_442",
  "p-vertical-xxxl": "awsui_p-vertical-xxxl_18wu0_837ww_443",
  "p-right-xxxl": "awsui_p-right-xxxl_18wu0_837ww_447",
  "p-horizontal-xxxl": "awsui_p-horizontal-xxxl_18wu0_837ww_448",
  "p-bottom-xxxl": "awsui_p-bottom-xxxl_18wu0_837ww_452",
  "p-left-xxxl": "awsui_p-left-xxxl_18wu0_837ww_457",
  "m-n": "awsui_m-n_18wu0_837ww_462",
  "m-top-n": "awsui_m-top-n_18wu0_837ww_466",
  "m-vertical-n": "awsui_m-vertical-n_18wu0_837ww_467",
  "m-right-n": "awsui_m-right-n_18wu0_837ww_471",
  "m-horizontal-n": "awsui_m-horizontal-n_18wu0_837ww_472",
  "m-bottom-n": "awsui_m-bottom-n_18wu0_837ww_476",
  "m-left-n": "awsui_m-left-n_18wu0_837ww_481",
  "m-xxxs": "awsui_m-xxxs_18wu0_837ww_486",
  "m-top-xxxs": "awsui_m-top-xxxs_18wu0_837ww_490",
  "m-vertical-xxxs": "awsui_m-vertical-xxxs_18wu0_837ww_491",
  "m-right-xxxs": "awsui_m-right-xxxs_18wu0_837ww_495",
  "m-horizontal-xxxs": "awsui_m-horizontal-xxxs_18wu0_837ww_496",
  "m-bottom-xxxs": "awsui_m-bottom-xxxs_18wu0_837ww_500",
  "m-left-xxxs": "awsui_m-left-xxxs_18wu0_837ww_505",
  "m-xxs": "awsui_m-xxs_18wu0_837ww_510",
  "m-top-xxs": "awsui_m-top-xxs_18wu0_837ww_514",
  "m-vertical-xxs": "awsui_m-vertical-xxs_18wu0_837ww_515",
  "m-right-xxs": "awsui_m-right-xxs_18wu0_837ww_519",
  "m-horizontal-xxs": "awsui_m-horizontal-xxs_18wu0_837ww_520",
  "m-bottom-xxs": "awsui_m-bottom-xxs_18wu0_837ww_524",
  "m-left-xxs": "awsui_m-left-xxs_18wu0_837ww_529",
  "m-xs": "awsui_m-xs_18wu0_837ww_534",
  "m-top-xs": "awsui_m-top-xs_18wu0_837ww_538",
  "m-vertical-xs": "awsui_m-vertical-xs_18wu0_837ww_539",
  "m-right-xs": "awsui_m-right-xs_18wu0_837ww_543",
  "m-horizontal-xs": "awsui_m-horizontal-xs_18wu0_837ww_544",
  "m-bottom-xs": "awsui_m-bottom-xs_18wu0_837ww_548",
  "m-left-xs": "awsui_m-left-xs_18wu0_837ww_553",
  "m-s": "awsui_m-s_18wu0_837ww_558",
  "m-top-s": "awsui_m-top-s_18wu0_837ww_562",
  "m-vertical-s": "awsui_m-vertical-s_18wu0_837ww_563",
  "m-right-s": "awsui_m-right-s_18wu0_837ww_567",
  "m-horizontal-s": "awsui_m-horizontal-s_18wu0_837ww_568",
  "m-bottom-s": "awsui_m-bottom-s_18wu0_837ww_572",
  "m-left-s": "awsui_m-left-s_18wu0_837ww_577",
  "m-m": "awsui_m-m_18wu0_837ww_582",
  "m-top-m": "awsui_m-top-m_18wu0_837ww_586",
  "m-vertical-m": "awsui_m-vertical-m_18wu0_837ww_587",
  "m-right-m": "awsui_m-right-m_18wu0_837ww_591",
  "m-horizontal-m": "awsui_m-horizontal-m_18wu0_837ww_592",
  "m-bottom-m": "awsui_m-bottom-m_18wu0_837ww_596",
  "m-left-m": "awsui_m-left-m_18wu0_837ww_601",
  "m-l": "awsui_m-l_18wu0_837ww_481",
  "m-top-l": "awsui_m-top-l_18wu0_837ww_610",
  "m-vertical-l": "awsui_m-vertical-l_18wu0_837ww_611",
  "m-right-l": "awsui_m-right-l_18wu0_837ww_615",
  "m-horizontal-l": "awsui_m-horizontal-l_18wu0_837ww_616",
  "m-bottom-l": "awsui_m-bottom-l_18wu0_837ww_620",
  "m-left-l": "awsui_m-left-l_18wu0_837ww_625",
  "m-xl": "awsui_m-xl_18wu0_837ww_630",
  "m-top-xl": "awsui_m-top-xl_18wu0_837ww_634",
  "m-vertical-xl": "awsui_m-vertical-xl_18wu0_837ww_635",
  "m-right-xl": "awsui_m-right-xl_18wu0_837ww_639",
  "m-horizontal-xl": "awsui_m-horizontal-xl_18wu0_837ww_640",
  "m-bottom-xl": "awsui_m-bottom-xl_18wu0_837ww_644",
  "m-left-xl": "awsui_m-left-xl_18wu0_837ww_649",
  "m-xxl": "awsui_m-xxl_18wu0_837ww_654",
  "m-top-xxl": "awsui_m-top-xxl_18wu0_837ww_658",
  "m-vertical-xxl": "awsui_m-vertical-xxl_18wu0_837ww_659",
  "m-right-xxl": "awsui_m-right-xxl_18wu0_837ww_663",
  "m-horizontal-xxl": "awsui_m-horizontal-xxl_18wu0_837ww_664",
  "m-bottom-xxl": "awsui_m-bottom-xxl_18wu0_837ww_668",
  "m-left-xxl": "awsui_m-left-xxl_18wu0_837ww_673",
  "m-xxxl": "awsui_m-xxxl_18wu0_837ww_678",
  "m-top-xxxl": "awsui_m-top-xxxl_18wu0_837ww_682",
  "m-vertical-xxxl": "awsui_m-vertical-xxxl_18wu0_837ww_683",
  "m-right-xxxl": "awsui_m-right-xxxl_18wu0_837ww_687",
  "m-horizontal-xxxl": "awsui_m-horizontal-xxxl_18wu0_837ww_688",
  "m-bottom-xxxl": "awsui_m-bottom-xxxl_18wu0_837ww_692",
  "m-left-xxxl": "awsui_m-left-xxxl_18wu0_837ww_697",
  "d-block": "awsui_d-block_18wu0_837ww_702",
  "d-inline": "awsui_d-inline_18wu0_837ww_705",
  "d-inline-block": "awsui_d-inline-block_18wu0_837ww_708",
  "d-none": "awsui_d-none_18wu0_837ww_711",
  "f-left": "awsui_f-left_18wu0_837ww_715",
  "f-right": "awsui_f-right_18wu0_837ww_719"
};
  